
import { useState } from "react"
import { SignUpEmailAndPassword } from "./Firebase";
import { ShakeIt } from "../App";
 
const SignUp = ( ) => {
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");

    const onSubmit = (e) => {
        e.preventDefault()

        let states = ['userName', 'email', 'password', 'confirm']
        var valid = true
        states.forEach((signUpState) => {
            switch (signUpState){
                case 'userName':
                    if (userName === "") {document.getElementsByClassName("form-control")[0].firstChild.classList.add('form-required'); valid = false} 
                    else document.getElementsByClassName("form-control")[0].firstChild.classList.remove('form-required')

                    break;
                case 'email':
                    if (email === "") {document.getElementsByClassName("form-control")[1].firstChild.classList.add('form-required'); valid = false}
                    else document.getElementsByClassName("form-control")[1].firstChild.classList.remove('form-required')
                    break;
                case 'password':
                    if (password === "") {document.getElementsByClassName("form-control")[2].firstChild.classList.add('form-required'); valid = false}
                    else document.getElementsByClassName("form-control")[2].firstChild.classList.remove('form-required')
                    break;
                case 'confirm':
                    if (confirm === "") {document.getElementsByClassName("form-control")[3].firstChild.classList.add('form-required'); valid = false}
                    else document.getElementsByClassName("form-control")[3].firstChild.classList.remove('form-required')
                    break;
                default:
                    break;
                
            }
        })

        
        // onSignIn()
        if (valid){
            if (password === confirm) SignUpEmailAndPassword(email, password)
            else alert('password and confirmation does not match')
        }else{
            ShakeIt('signUp')
        }
    }

    return (
        <div>
            <div id='signUp' onSubmit={onSubmit} className='login-form sign-up hide'>
                <h2>Sign Up</h2>
                <form>
                    <div className='form-control'>
                        <input type='text' placeholder='USERNAME' value={userName} onChange={(e) => {setUserName(e.target.value)}}></input>
                    </div>
                    <div className='form-control'>
                        <input type='email' placeholder='EMAIL' value={email} onChange={(e) => {setEmail(e.target.value)}}></input>
                    </div>
                    <div className='form-control' value={password} onChange={(e) => {setPassword(e.target.value)}}>
                        <input type='password' placeholder='PASSWORD'></input>
                    </div>
                    <div className='form-control'>
                        <input type='password' placeholder='CONFIRM PASSWORD' value={confirm} onChange={(e) => {setConfirm(e.target.value)}}></input>
                    </div>

                    <input type='submit' value='CREATE ACCOUNT' className='btn-block' style={{borderRadius:"25px", display:'block', margin:'5rem auto 1.3rem auto'}} />

                    <div className='form-control'>
                        <a style={{display: 'block', marginBottom:'0.8rem', cursor:'pointer'}} onClick={() => {
                            document.getElementById("login").classList.remove('hide');
                            
                            setTimeout(() => {
                                document.getElementById("login").style.top = "0px"; 
                                document.getElementById("signUp").style.top = "-2500px";
                            }, 1)
                            setTimeout(() => {
                                document.getElementById("signUp").classList.add('hide');
                            }, 500)
                            var elems = document.querySelectorAll(".form-required");
                            elems.forEach((elem) => {elem.classList.remove('form-required')})
                        }}>Already have an account?</a>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default SignUp
